import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  height: ", ";\n  padding: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: normal;\n  margin: 0;\n  user-select: none;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      font-weight: 700;\n      color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  box-sizing: border-box;\n  font-size: ", ";\n  border-top: ", ";\n  border-right: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor: pointer;\n\n  ", "\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  max-height: ", ";\n  box-sizing: border-box;\n  outline: 0;\n  width:  160px;\n  padding: 10px 0;\n  border: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  z-index: ", ";\n  transform: ", ";\n  transform-origin: top center;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef } from 'react';
import * as R from 'ramda';
import styled, { css } from 'styled-components';
import { position, layout, space, shadow } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Downshift from 'downshift';
import posed, { PoseGroup } from 'react-pose';
import Popper from '../popper/Popper';
import { Flex, Box } from '../grid/Grid';
var Content = styled.div(_templateObject());
var Animation = posed.div({
  enter: {
    opacity: 1,
    scale: 1,
    x: function x(_ref) {
      var _x = _ref.x;
      return _x;
    },
    y: function y(_ref2) {
      var _y = _ref2.y;
      return _y;
    },
    transition: {
      duration: 150,
      ease: 'circOut'
    }
  },
  exit: {
    opacity: 0,
    scale: 0.8,
    x: function x(_ref3) {
      var _x2 = _ref3.x;
      return _x2;
    },
    y: function y(_ref4) {
      var _y2 = _ref4.y;
      return _y2;
    },
    transition: {
      duration: 0,
      ease: 'backOut'
    },
    delay: 0
  }
});
var MenuWrapper = styled(Animation)(_templateObject2(), themeGet('dropdown.menu.maxHeight'), themeGet('dropdown.menu.border'), themeGet('dropdown.menu.borderColor'), themeGet('dropdown.menu.borderRadius'), themeGet('dropdown.menu.boxShadow'), themeGet('dropdown.menu.backgroundColor'), themeGet('dropdown.menu.zIndex'), function (_ref5) {
  var x = _ref5.x;
  return x ? "translateX(".concat(x, ")") : 'unset';
}, position, layout, space, shadow);
MenuWrapper.defaultProps = {
  x: 0
};
var Menu = styled.ul(_templateObject3());
var Item = styled.li(_templateObject4(), themeGet('dropdown.option.padding'), themeGet('dropdown.option.fontSize'), themeGet('dropdown.option.border.top'), themeGet('dropdown.option.border.right'), themeGet('dropdown.option.border.bottom'), themeGet('dropdown.option.border.left'), themeGet('dropdown.option.boxShadow'), themeGet('dropdown.option.color'), themeGet('dropdown.option.backgroundColor'), function (props) {
  return props.hovered && css(_templateObject5(), themeGet('dropdown.option.hover.color'), themeGet('dropdown.option.hover.backgroundColor'));
}, function (props) {
  return props.selected && css(_templateObject6(), themeGet('dropdown.option.selected.color'), themeGet('dropdown.option.selected.backgroundColor'));
});
var Label = styled.h3(_templateObject7(), themeGet('dropdown.option.fontSize'));
var OptionBlock = styled.div(_templateObject8(), themeGet('dropdown.option.height'));
/**
 * @typedef DropdownProps
 * @property {any} selectedItem
 * @property {(item) => void} onChange
 * @property {any[]} options
 * @property {boolean} disablePortal
 * @property {boolean} disabledPopper
 * @property {() => React.ReactElement} render
 * @property {'bottom' | 'bottomLeft' | 'bottomRight' | 'top' | 'topLeft' | 'topRight'} placement
 */

/**
 * @param {DropdownProps} props
 */

export var Dropdown = function Dropdown(_ref6) {
  var selectedItem = _ref6.selectedItem,
      onChange = _ref6.onChange,
      options = _ref6.options,
      _ref6$render = _ref6.render,
      render = _ref6$render === void 0 ? function () {} : _ref6$render,
      renderOption = _ref6.renderOption,
      _ref6$menuWrapperStyl = _ref6.menuWrapperStyle,
      menuWrapperStyle = _ref6$menuWrapperStyl === void 0 ? {} : _ref6$menuWrapperStyl,
      _ref6$disablePortal = _ref6.disablePortal,
      disablePortal = _ref6$disablePortal === void 0 ? false : _ref6$disablePortal,
      _ref6$disabledPopper = _ref6.disabledPopper,
      disabledPopper = _ref6$disabledPopper === void 0 ? false : _ref6$disabledPopper,
      _ref6$placement = _ref6.placement,
      placement = _ref6$placement === void 0 ? 'bottomLeft' : _ref6$placement,
      rest = _objectWithoutProperties(_ref6, ["selectedItem", "onChange", "options", "render", "renderOption", "menuWrapperStyle", "disablePortal", "disabledPopper", "placement"]);

  var ele = useRef(null);
  return (
    /*#__PURE__*/
    React.createElement(Downshift, _extends({
      itemToString: R.identity,
      selectedItem: selectedItem,
      onChange: onChange
    }, rest), function (_ref7) {
      var getInputProps = _ref7.getInputProps,
          getMenuProps = _ref7.getMenuProps,
          getItemProps = _ref7.getItemProps,
          getRootProps = _ref7.getRootProps,
          isOpen = _ref7.isOpen,
          selectedItem = _ref7.selectedItem,
          highlightedIndex = _ref7.highlightedIndex,
          toggleMenu = _ref7.toggleMenu;

      var defaultRenderOption = function defaultRenderOption(item) {
        return (
          /*#__PURE__*/
          React.createElement(Item, {
            key: item.name
          },
          /*#__PURE__*/
          React.createElement(OptionBlock, null,
          /*#__PURE__*/
          React.createElement(Flex, {
            flexDirection: "row",
            alignItems: "center"
          },
          /*#__PURE__*/
          React.createElement(Box, {
            mr: "5px"
          }, item.icon),
          /*#__PURE__*/
          React.createElement(Label, null, item.name))))
        );
      };

      var renderOptionCb = renderOption || defaultRenderOption;
      var rootProps = getRootProps();
      return (
        /*#__PURE__*/
        React.createElement(Content, _extends({}, rootProps, {
          ref: function ref(node) {
            ele.current = node;
            rootProps.ref(node);
          }
        }), render({
          getInputProps: getInputProps,
          getMenuProps: getMenuProps,
          getItemProps: getItemProps,
          isOpen: isOpen,
          selectedItem: selectedItem,
          highlightedIndex: highlightedIndex,
          toggleMenu: toggleMenu
        }),
        /*#__PURE__*/
        React.createElement(Popper, {
          key: "popper",
          disabledPopper: disabledPopper,
          disablePortal: disablePortal,
          keepMounted: true,
          open: isOpen && options,
          referRef: ele,
          placement: placement
        }, function (_ref8) {
          var open = _ref8.open;
          return (
            /*#__PURE__*/
            React.createElement(PoseGroup, null, open &&
            /*#__PURE__*/
            React.createElement(MenuWrapper, _extends({
              key: "menu"
            }, menuWrapperStyle),
            /*#__PURE__*/
            React.createElement(Menu, getMenuProps(), R.pipe(R.map(renderOptionCb), R.addIndex(R.map)(function (item, index) {
              return (
                /*#__PURE__*/
                React.cloneElement(item, getItemProps({
                  item: options[index],
                  index: index,
                  hovered: highlightedIndex === index,
                  selected: selectedItem === options[index],
                  disabled: item.disabled
                }))
              );
            }))(options))))
          );
        }))
      );
    })
  );
};